/*=========================================================================================
  File Name: moduleCustomerMutations.js
  Description: Customer Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  
};
